import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import { useTheme } from '@mui/material';

export const Profile = ({ size = 'large' }) => {
  const theme = useTheme();

  return (
    <AccountCircleIcon
      fontSize={size}
      sx={{ color: theme.palette.tertiary.main }}
    />
  );
};
